export const POSTHOG_VISITOR_ID_COOKIE = 'workman_visitor_id';
export const POSTHOG_VISITOR_ID_HEADER = 'x-workman-visitor-id';

export function createPostHogVisitorId() {
	if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
		return `wv_${crypto.randomUUID()}`;
	}

	return `wv_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

export function getCookieValue(cookieHeader: string | undefined, name: string) {
	if (!cookieHeader) return null;

	const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	const match = cookieHeader.match(new RegExp(`(?:^|;\\s*)${escapedName}=([^;]*)`));
	if (!match?.[1]) return null;

	try {
		return decodeURIComponent(match[1]);
	} catch {
		return match[1];
	}
}
